(function() {
  var filter = require('../../../public/javascripts/js_maps/filter.js');
  // TODO make this non-destructive and look for all uses of it on
  // subsections of data (zooming in, TrackPoint.calculateSplits) and
  // make it so those methods no longer copy track points to deal with
  // this destructiveness
  //
  // the readOnly flag won't overwrite data with smoothed values - but the assumption is that
  // this has already been done. it is used specifically to prevent smoothing the data
  // multiple times, so do not use readOnly=true unless calculate() has already been run on
  // the full track data once.
  // See rwgps/data.js for examples of both usages, in Data and DataSlice respectively.

  // metrics is optional, used to preload the metrics calculator so calculation is not required
  var MetricsCalculator = function(data, readOnly, metrics, serverMode) {
    // not positive what the implications are of doing this across the
    // board, but definitely dont need to do this for the new elevation
    // profile so adding this setting... that way i can stop cloning
    // points and this can stop being destructive
    this.readOnly = readOnly;
    this.serverMode = !!serverMode;
    if(_.isArray(data))
      this._data = new rwgps.Data(data);
    else
      this._data = data;

    this._points = [];
    this._metrics = {};
    if(metrics && metrics.v == 1) {
      this._metrics = metrics;
      this.calculated = true;
    }
  };

  MetricsCalculator.version = 1;

  // speed-by-grade trip summary / estimated time settings
  var minSummaryGrade = -15;
  var maxSummaryGrade = 15;

  /*
   * Version 1 structure
   {
   "watts"=>{
   "normalized"=>184.3248112608079,
   "max"=>620,
   "min"=>11,
   "_min"=>1,
   "_max"=>620,
   "avg"=>161.6254295532646
   },
   "ele"=>{
   "max"=>460.038,
   "min"=>136.637,
   "_min"=>136.637,
   "_max"=>460.038,
   "avg"=>219.1570193591459
   },
   "hr"=>{
   "max"=>179,
   "min"=>90,
   "_min"=>90,
   "_max"=>179,
   "avg"=>149.82443257676903
   },
   "cad"=>{
   "max"=>186,
   "min"=>21,
   "_min"=>0,
   "_max"=>186,
   "avg"=>81.7462090981644
   },
   "watts_ma_30"=>{
   "max"=>416.48666666666696,
   "min"=>5.87857142857174,
   "_max"=>416.48666666666696,
   "_min"=>2.000000000000239,
   "avg"=>0
   },
   "watts_ma_60"=>{
   "max"=>317.0847222222222,
   "min"=>8.419047619047673,
   "_max"=>317.0847222222222,
   "_min"=>2.000000000000076,
   "avg"=>0
   },
   "speed"=>{
   "max"=>54.779,
   "min"=>0.09,
   "_max"=>55.30781253600027,
   "_min"=>0,
   "avg"=>22.055349092721098
   },
   "grade"=>{
   "max"=>18.421,
   "min"=>-16.605,
   "_max"=>38.1,
   "_min"=>-36.3,
   "avg"=>1.4174899866488644
   },
   "duration"=>8129,
   "movingTime"=>7949,
   "stoppedTime"=>180,
   "pace"=>166.9218506827479,
   "movingPace"=>163.22570932183086,
   "distance"=>48699.4360939,
   "startElevation"=>145.536,
   "endElevation"=>147.953,
   "numPoints"=>1526,
   "ele_gain"=>652.9000000000003,
   "ele_loss"=>650.851
   }
   */

  // MetricsCalculator.aggregate(metrics1, metrics2, metrics3, etc)
  // TODO: actually use this! or think of something smarter
  MetricsCalculator.aggregate = function() {
    return _.reduce(arguments, function(memo, metrics) {
      //if(!memo) return metrics;
      //trace(metrics);
      return metrics;

    }, null);
  }
  MetricsCalculator.prototype = {
    metrics: function() {
      if(!this.calculated) this.calculate();
      return this._metrics;
    },

    hasMetric: function(metric) {
      if(!this._metrics[metric]) return false;
      var m = this._metrics[metric]._max;
      return !(m === undefined || m === null || m == -50000 || isNaN(m));
    },

    // run fn on up to 10% of points, short circuit when fn is truthy
    limitedDetect: function(fn) {
      if(this._data.count > 0) {
        var checkCount = Math.ceil(this._data.count / 10);
        for(var i=0; i < checkCount; i++) {
          if(fn(this._data.points(i))) return true;
        }
      }
      return false;
    },

    hasPosition: function() {
      if(this._hasPosition === undefined) {
        this._hasPosition = this.limitedDetect(tp => tp.point);
      }
      return this._hasPosition;
    },

    hasTime: function() {
      return !!(this._data.points(0) && !isNaN(this._data.points(0).time) && this._data.points(0).time > 0);
    },

    hasDistance: function() {
      if(this._hasDistance === undefined) {
        var dist0;
        this._hasDistance = this.limitedDetect(function(tp) {
          // if the point has position, then the track has distance.
          if(tp.point) return true;
          // for stationary rides, sometimes provided dist is a nonchanging number. ensure it changes to say we have distance.
          if(_.isNumber(tp.providedDistance)) {
            if(dist0 === undefined) {
              dist0 = tp.providedDistance;
            } else if(tp.providedDistance - dist0 > 0) {
              return true;
            }
          }
        });
      }
      return this._hasDistance;
    },

    hasPower: function() {
      return this.limitedDetect(tp => tp.watts != null);
    },

    enabledMetrics: function() {
      var metrics, enabledMetrics = [];
      if (this.serverMode) {
        metrics = ["ele", "hr", "cad", "watts", "speed", "grade", "temp"];
      } else {
        metrics = ["ele", "surfaces", "hr", "cad", "watts", "watts_ma_30", "watts_ma_60", "speed", "grade", "temp"];
      }

      for (var i=0; i < metrics.length; i++) {
        if (this.hasMetric(metrics[i])) {
          enabledMetrics.push(metrics[i]);
        }
      }
      return enabledMetrics;
    },

    enabledBaseMetrics: function() {
      var metrics = ["ele", "hr", "cad", "watts", "speed", "grade", "temp"], enabledMetrics = [];

      for(var i=0; i < metrics.length; i++) {
        if(this.hasMetric(metrics[i]))
          enabledMetrics.push(metrics[i]);
      }
      return enabledMetrics;
    },

    getMetric: function(metric, prop) {
      var m = this._metrics;
      return m[metric] && m[metric][prop] ? m[metric][prop] : 0;
    },

    setMetric: function(metric, prop, value, i) {
      if(!this._metrics[metric]) this._metrics[metric] = {};
      this._metrics[metric][prop] = value;
      if(i) this._metrics[metric][prop + "_i"] = i;
    },

    removeMetric: function(metric) {
      delete this._metrics[metric];
    },

    setHRZoneBoundaries: function(hrZoneBoundaries) {
      this._hrZoneBoundaries = hrZoneBoundaries
    },

    getHRZoneBoundaries: function() {
      return this._hrZoneBoundaries
    },

    calculate: function(abortIfCalculated) {
      if(this._data.count < 2) return {};
      if(abortIfCalculated && this.calculated) {
        return this._metrics;
      }
      // i benchmarked copying points from slices, or referencing them. copying is faster.
      this._points = this._data.points();

      var i;
      var metrics;
      if(this.serverMode)
        metrics = ["ele", "hr", "cad", "watts", "speed", "grade", "temp"];
      else
        metrics = ["ele", "surfaces", "hr", "cad", "watts", "watts_ma_30", "watts_ma_60", "speed", "grade", "temp"];
      var hasTime = this.hasTime();
      var d = this._data;
      var point;
      var hasPower = this.hasPower();
      var hasDistance = this.hasDistance();
      var includedNonInitialPoint;
      var distance = 0;
      var elevationGain = 0;
      var elevationLoss = 0;
      var ascentTime = 0;
      var descentTime = 0;
      var duration;
      var movingTime;
      var stoppedTime;
      var count = 0;
      var minCadAllowed = 10;
      var minWattsAllowed = 10;
      var firstTime;
      var bounds = this._bounds = {
        sw: {lat: 90, lng: 180},
        ne: {lat: -90, lng: -180}
      };

      if(hasPower) {
        if(this.serverMode) {
          // calculate all the moving averages we need to get the single best efforts we store on server
          this._metrics.bestEfforts = this.calculateMovingAverages('watts', [5,10,15,20,30,60,60*5,60*10,60*20,60*30,60*60,60*90]);
        } else {
          // this is what is displayed as options in sample graph
          this.calculateMovingAverages('watts', [30,60]);
        }
        this.calculateNormalizedPower();
      }

      //we must explicitly set these, since it is possible for the first
      //of the points to have a zero value.  in that case, min elevation
      //for example, would be zero, even tho it's an outlier.
      point = d.points(0);
      for(i = 0; i < metrics.length; i++) {
        var metric = metrics[i];
        this.setMetric(metric, 'max', -50000);
        this.setMetric(metric, 'min', 50000);
      }

      if(hasTime) {
        movingTime = 0;
        stoppedTime = 0;
        firstTime = point.time;
      }

      var points = this._points;

      var delta;
      var prevPoint;
      var distanceWithoutExcludedPoints = 0;
      //set start and end of route to have 0 grade, if we dont' have it already
      //set by ruby and data_full
      if(!this.readOnly) {
        var firstpt = d.points(0);
        if(isNaN(firstpt.grade) && !isNaN(firstpt.ele)) {
          firstpt.grade = firstpt.grade_orig = 0;
        }
        if(isNaN(firstpt.speed) && hasDistance) {
          firstpt.speed = 0;
        }
        firstpt.distance = 0;

        // set distances.
        point = null;
        for(i = 0; i < d.count; i++) {
          if (point && (point.providedDistance !== undefined || point.point))
            prevPoint = point;
          point = points[i];
          includedNonInitialPoint = prevPoint && (!prevPoint.excludeFromMetrics || !point.excludeFromMetrics)
          if(point.point) {
            if(point.point.lat < -90 || point.point.lat > 90 ||
              point.point.lng < -180 || point.point.lng > 180) {
              point.point = null
            }
          }

          if(prevPoint) {
            if(prevPoint.providedDistance !== undefined && point.providedDistance !== undefined) {
              delta = point.providedDistance - prevPoint.providedDistance;
            } else if(point.point && prevPoint.point) {
              delta = point.distanceFromPoint(prevPoint);
            } else {
              delta = 0
            }
            distance += delta
            if(includedNonInitialPoint) {
              distanceWithoutExcludedPoints += delta
            }
          }
          point.distance = distance;
          point.distanceWithoutExcludedPoints = distanceWithoutExcludedPoints;
        }
        // reset distance because it will be set in the next loop;
        distance = 0;
      }
      var smoothedEles = this.smoothEles();

      // goodPoint is set when distance exists or can be derived (and is used for speed setting)
      // when true, prevPoint is reassigned, otherwise points are skipped over for speed calcs, unless stationary
      var goodPoint = false;
      point = null;
      prevPoint = null;

      // moving time gets increased when cad/watts are present, without distance values. prevPoint only
      // gets reassigned when distance values are present. so, we need a moving time specific version of "prevPoint"
      // to track time deltas
      var movingTimePrevPoint;
      var movingTimeDelta = 0;
      var moving = false;
      var lastGoodSpeed;
      for(i = 0; i < d.count; i++) {
        moving = false;
        if (goodPoint) prevPoint = point;
        if (hasTime && point && point.time) movingTimePrevPoint = point;
        point = points[i];
        includedNonInitialPoint = prevPoint && (!prevPoint.excludeFromMetrics || !point.excludeFromMetrics)
        goodPoint = (point.providedDistance !== undefined || point.point);
        if(!prevPoint) {
          delta = 0;
        } else if(prevPoint.providedDistance !== undefined && point.providedDistance !== undefined) {
          delta = point.providedDistance - prevPoint.providedDistance;
        } else if(prevPoint.distance !== undefined && point.distance !== undefined) {
          delta = point.distance - prevPoint.distance;
        } else if(point.point && prevPoint.point) {
          // This case will probably not happen as it is covered above.
          delta = point.distanceFromPoint(prevPoint);
        } else {
          delta = 0;
        }
        if(delta && includedNonInitialPoint)
          distance += delta;

        if(hasTime && point.time && includedNonInitialPoint && prevPoint.time && prevPoint.time != point.time) {
          var timedelta = point.time - prevPoint.time;
          var speed = (timedelta == 0 ? 0 : delta / timedelta) / 1000.0 * 3600;
          if(!Number.isFinite(point.speed) && hasDistance) {
            point.speed = speed;
            //if over 100kph and we detect a major speed outlier (big jump), kill it
            if(speed > 100 && Number.isFinite(lastGoodSpeed)) {
              var speedDelta = (speed - lastGoodSpeed) / timedelta;
              //motorcycle can do 0-100kph in 3 seconds or so, so upper bound
              //with 40kph per second acceleration
              if(lastGoodSpeed * 1.5 < speed && speedDelta > 40) {
                point.speed = undefined;
              }
            }
          }
          //we use the calculated speed as a double check
          //This is because when a garmin auto-pauses, the
          //two points at the start and end of pause might have a speed of 7m/s,
          //but they have the same distance and similar lat/lng, meaning there is
          //just a delay in the sensor readings from the garmin.
          var speedThreshold = 3.2;
          movingTimeDelta = point.time - movingTimePrevPoint.time;
          if(movingTimeDelta <= 32 && ((point.speed > speedThreshold && speed > speedThreshold) ||
                                 (point.cad && point.cad > minCadAllowed) ||
                                 (point.watts && point.watts > minWattsAllowed))) {
            //speed is greater than 2mph or cad/watts sufficient
            movingTime += movingTimeDelta;
            count += 1;
            moving = true;
          } else if(hasDistance) {
            // this exclude flag is used to consider the user stopped and will be excluded from maxes/mins/avgs.
            prevPoint.exclude = true;
            point.exclude = true;
            // we're here because timedelta is big, or because we don't want to consider the user moving.
            // if timedelta is big, we end up with bogus-looking long lines from (for example)
            // 3mph to 16mph stretched across a 30 minute gap (lunch with smart recording).  in the case of
            // a large timedelta, set the speeds to 0 to avoid this bogus-looking graph situation.
            if(movingTimeDelta > 32) {
              prevPoint.speed = 0;
              point.speed = 0;
            }
          }
        } else {
          count += 1; //for routes, still need to count all the points
        }

        if (!goodPoint && this.hasPosition())
          point.speed = null;

        // Must stay after the clamp and resets so a discarded speed never becomes the next baseline.
        if(Number.isFinite(point.speed)) lastGoodSpeed = point.speed;

        if(point.point) {
          if(point.point.lng > bounds["ne"]['lng']) bounds["ne"]['lng'] = point.point.lng;
          if(point.point.lat > bounds["ne"]['lat']) bounds["ne"]['lat'] = point.point.lat;
          if(point.point.lng < bounds["sw"]['lng']) bounds["sw"]['lng'] = point.point.lng;
          if(point.point.lat < bounds["sw"]['lat']) bounds["sw"]['lat'] = point.point.lat;
        }

        var eleIdx = smoothedEles.idxMap[i];
        if(eleIdx && eleIdx > 0) {
          var eleDiff = smoothedEles.results[eleIdx] - smoothedEles.results[eleIdx-1];
          if(includedNonInitialPoint) {
            if(eleDiff < 0 && eleDiff > -500) {
              elevationLoss -= eleDiff;
              if(hasTime && moving && point.time && prevPoint.time) 
                descentTime += point.time - prevPoint.time;
            } else if(eleDiff > 0 && eleDiff < 500) {
              elevationGain += eleDiff;
              if(hasTime && moving && point.time && prevPoint.time) 
                ascentTime += point.time - prevPoint.time;
            }
          }

          if(!isNaN(eleDiff) && (isNaN(point.grade) || point.grade == null)) { //don't go out of index for grade calc
            point.grade = point.grade_orig = delta == 0 ? 0 : parseInt((eleDiff / delta * 100) * 10.0) / 10.0;
            if(Math.abs(point.grade) > 40 && prevPoint) //toss outliers, 40% grade is HUGE
              point.grade = point.grade_orig = prevPoint.grade;
          }
        }
      }

      var ptCount, // count all points with the metric defined
          ptSum,
          filteredPtCount, // only count "considered" points (moving, >= 10 for cad or watts)
          filteredPtSum;

      for(var j = 0; j < metrics.length; j++) {
        metric = metrics[j];
        ptCount = ptSum = filteredPtCount = filteredPtSum = 0;

        // for time-weighted average
        var totalTime=0, metricSeconds=0, lastTime=points[0].time, timeDiff=0, lastVal=null, valAvg;

        for(i = 0; i < d.count; i++) {
          point = points[i];
          if(point[metric] === null || isNaN(point[metric])) { continue; }
          ptCount++;
          ptSum += point[metric];

          // build up a time-weighted average if we have time data
          if(hasTime) {
            if(lastVal !== null) {
              timeDiff = point.time - lastTime;
              valAvg = (point[metric] + lastVal) / 2;
              if(timeDiff > 180) {
                valAvg = 0;
              }
              totalTime += timeDiff;
              metricSeconds += timeDiff * valAvg;
            }
            lastTime = point.time;
            lastVal = point[metric];
          }

          if(point[metric] < this._metrics[metric]['_min'] || this._metrics[metric]['_min'] === undefined)
            this.setMetric(metric, '_min', point[metric]);
          if(point[metric] > this._metrics[metric]['_max'] || this._metrics[metric]['_max'] === undefined) {
            this.setMetric(metric, '_max', point[metric]);
          }

          if(!point.exclude) {
            if(metric == 'cad') {
              if(point[metric] < minCadAllowed) continue;
              filteredPtCount++;
            } else if(metric == "watts") {
              if(point[metric] < minWattsAllowed) continue;
              filteredPtCount++;
            } else {
              filteredPtCount++;
            }
            if(point[metric] > this.getMetric(metric, 'max'))  {
              this.setMetric(metric, 'max', point[metric], i);
            }
            if(point[metric] < this.getMetric(metric, 'min'))
              this.setMetric(metric, 'min', point[metric], i);

            if(metric != 'speed' || hasTime) {
              filteredPtSum += point[metric];
            }
          }
        }
        if(ptCount > 0) {
          if(hasTime) {
            // time-weighted average
            this.setMetric(metric, '_avg', totalTime > 0 ? metricSeconds / totalTime : 0);
          } else {
            // simple average
            this.setMetric(metric, '_avg', ptSum / d.count);
          }
          if(filteredPtCount > 0) {
            this.setMetric(metric, 'avg', filteredPtSum / filteredPtCount);
          }
        } else {
          this.removeMetric(metric);
        }
      }
      if(hasTime) {
        lastTime = d.points(d.count - 1).time;
        if(!lastTime) lastTime = d.points(d.count - 2).time;
        duration = lastTime - d.points(0).time;
        if(duration > 0) {
          stoppedTime = duration - movingTime;
          this._metrics['stationary'] = !this.hasPosition();
          this._metrics['duration'] = duration;
          this._metrics['firstTime'] = firstTime;
          this._metrics['movingTime'] = movingTime;
          this._metrics['stoppedTime'] = stoppedTime;
          this._metrics['pace'] = distance > 0 ? duration / (distance / 1000) : 0;
          this._metrics['movingPace'] = distance > 0 ? movingTime / (distance / 1000) : 0;
          this._metrics['ascentTime'] = ascentTime;
          this._metrics['descentTime'] = descentTime;
          this._metrics['vam'] = ascentTime>0 ? elevationGain / (ascentTime / 3600) : 0;
          if(hasPower) this._metrics['kJ'] = this._metrics.watts._avg * duration / 1000;
          if(this._metrics.speed && movingTime > 0)
            this._metrics.speed.avg = (distance / 1000) / (movingTime / 3600);
        } else {
          delete this._metrics.speed;
        }
      }

      // heuristics to clean up data if we detect this is stationary
      // with bad speed/distance
      if(this._metrics.speed && this.hasTime() && this._metrics.speed.avg < 0.3) {
        delete this._metrics.speed;
        this._hasDistance = false;
        this._hasPosition = false;
      }
      this.calculateGradeAndSpeed();

      // build speed-by-grade summary for server / estimate moving time for user
      if (this.hasPosition()) {
        if (this.serverMode && hasTime) {
          this._metrics['tripSummary'] = this.buildTripSummary();
        } else if (rwgps.summary && rwgps.summary.user_summary) {
          this._metrics['estimatedTime'] = this.estimateTimeFor(rwgps.summary.user_summary);
        }
      }

      // build distance-by-grade summary
      if (this.serverMode && this.hasPosition() && hasDistance) {
        this._metrics['routeSummary'] = this.buildRouteSummary();
      }

      const zoneBoundaries = this._hrZoneBoundaries
      if (zoneBoundaries && hasTime) {
        let hrZones = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }
        let hasHr = false
        for (let i = 0; i < points.length; ++i) {
          const point = points[i]
          if (point.exclude) { continue }

          const hrVal = point['hr']
          // Ignore bogus heartrate values
          if (!Number.isFinite(hrVal)) { continue }

          let zone = 6
          for(; zone > 0 && hrVal < zoneBoundaries[zone - 1]; --zone);
          if (zone > 5 || zone < 1) { continue }

          const prevPoint = points[i - 1]
          const nextPoint = points[i + 1]
          const t0 = (prevPoint && !prevPoint.exclude ? prevPoint : point).time
          const t1 = (nextPoint && !nextPoint.exclude ? nextPoint : point).time
          const duration = (t1 - t0) / 2.0

          // Missing 't' values can lead to bogus durations - ignore them
          if (!Number.isFinite(duration)) { continue }

          hasHr = true
          hrZones[zone] = (hrZones[zone] || 0) + duration
        }
        if (hasHr) { this._metrics["hr_zones"] = hrZones }
      }

      this._metrics["distance"] = distance; //manually add this in
      this._metrics['startElevation'] = d.points(0).ele;
      this._metrics['endElevation'] = d.points(d.count - 1).ele;
      this._metrics['numPoints'] = d.count;
      this._metrics["ele_gain"] = elevationGain;
      this._metrics["ele_loss"] = elevationLoss;

      if (this.hasSurface()) {
        this._metrics['surfaces'] = this.calculateSurfaceTypes();
      }

      this.calculated = true;
      if(elevationGain > 50 && elevationLoss/elevationGain < 0.2) {
        this._metrics['isClimb'] = true;
        this.calculateUCIClimbRating();
        this.calculateFietsIndex();
      }
      this._metrics['v'] = MetricsCalculator.version;

      return this._metrics;
    },

    buildTripSummary: function() {
      var points = this._points,
        gradeSpeeds = {},
        tripSummary = {},
        i;

      for(i = minSummaryGrade; i <= maxSummaryGrade; i++) {
        gradeSpeeds[i.toString()] = [];
      }

      var lastGoodIdx = -1;
      for(i = 0; i < points.length; i++) {
        var point = points[i],
          grade = point["grade"];
        if(!_.isFinite(grade) || !_.isFinite(point["speed"]) || point["exclude"] === true) {
          continue;
        }
        if(lastGoodIdx > -1) {
          if(grade > maxSummaryGrade) { grade = maxSummaryGrade; }
          if(grade < minSummaryGrade) { grade = minSummaryGrade; }
          gradeSpeeds[(Math.round(grade)).toString()].push(point["speed"]);
        }
        lastGoodIdx = i;
      }

      for(i = minSummaryGrade; i <= maxSummaryGrade; i++) {
        var speeds = gradeSpeeds[i],
          count = speeds.length,
          total, average;
        if(count === 0) {
          average = 0
        } else {
          total = speeds.reduce(function(a, b) {
                    return ((a === undefined) ? 0 : a) + ((b === undefined) ? 0 : b);
                  });
          average = total/count;
        }
        tripSummary[i] = [average, count];
      }
      return tripSummary;
    },

    buildRouteSummary: function() {
      var points = this._points,
        gradeDistance = {},
        routeSummary = {},
        i;

      for(i = minSummaryGrade; i <= maxSummaryGrade; i++) {
        gradeDistance[i.toString()] = [];
      }

      var lastGoodI = -1;
      for(i = 0; i < points.length; i++) {
        var point = points[i];
        if(!_.isFinite(point["grade"])) {
          continue;
        }
        if(lastGoodI > -1) {
          var currentDistance = point["distance"] - points[lastGoodI]["distance"],
            avgGrade = (points[i]["grade"] + points[lastGoodI]["grade"]) / 2,
            key = Math.round(avgGrade);
          if(key > maxSummaryGrade) { key = maxSummaryGrade; }
          if(key < minSummaryGrade) { key = minSummaryGrade; }
          gradeDistance[key.toString()].push(currentDistance);
        }
        lastGoodI = i;
      }

      for(i = minSummaryGrade; i <= maxSummaryGrade; i++) {
        if(gradeDistance[i].length === 0) {
          routeSummary[i] = 0;
        } else {
          var total = gradeDistance[i].reduce(function(a, b) {
            return ((a === undefined) ? 0 : a) + ((b === undefined) ? 0 : b);
          });
          routeSummary[i] = total;
        }
      }
      return routeSummary;
    },

    estimateTimeFor: function(userSummary) {
      var routeSummary = this.buildRouteSummary(),
        time = 0;
      Object.keys(routeSummary).forEach(function(grade) {
        if(grade > maxSummaryGrade) { userSummary[grade] = userSummary[maxSummaryGrade.toString()]; }
        if(grade < minSummaryGrade) { userSummary[grade] = userSummary[minSummaryGrade.toString()]; }

        // 1000 is for conversion between speed in kph & distance in meters
        time += (routeSummary[grade] / 1000) / userSummary[grade][0];
      });

      // time is in hours due to speed being in kph
      return time * 3600;
    },

    calculateUCIClimbRating: function() {
      var metrics = this.metrics(),
          uciCategory,
          uciScore = metrics.uciScore = metrics.distance * this.getMetric('grade', 'avg');
      if(uciScore > 64000) uciCategory = 'HC';
      else if(uciScore > 48000) uciCategory = 1;
      else if(uciScore > 32000) uciCategory = 2;
      else if(uciScore > 16000) uciCategory = 3;
      else if(uciScore > 8000) uciCategory = 4;
      metrics.uciCategory = uciCategory;
    },

    calculateFietsIndex: function() {
      var metrics = this.metrics(),
          maxEle = this.getMetric('ele', 'max'),
          minEle = this.getMetric('ele', 'min'),
          h = maxEle - minEle,
          d = metrics.distance,
          t = maxEle;
      metrics.fietsIndex = h*h / (d*10) + (t > 1000 ? (t-1000)/1000.0 : 0);
    },

    // example use: calculateMovingAverages('watts', [30, 60])
    calculateMovingAverages: function(metric, windowDurations) {
      if(!this._points[0] || this._points[0].hasOwnProperty('watts_ma_'+windowDurations[0])) {
        return;
      }
      // filter out points with duplicate time value, and without watts
      var points = [], d = this._data, allpoints = this._points;
      var prevPoint = null, p=null;
      for(var i=0,len=d.count;i < len;i++) {
        prevPoint = p;
        p = allpoints[i];
        p._idx = i;
        if((i == 0 || p.time != prevPoint.time) && _.isNumber(p.watts))
          points.push(p);
      }
      // need at least a couple points to not throw an error..
      if(points.length <= 2) return {};
      var baseMetric = 'watts', n, max=0, max_i, maxes={};
      for(var durI=0; durI < windowDurations.length; durI++) {
        max = 0;
        n = windowDurations[durI];
        var avgMetric = baseMetric + '_ma_' + n;
        var halfN = n/2;
        var firstT = points[0].time;
        var lastT = points[points.length-1].time;
        i = 0;
        // find first point that is >= n/2 seconds in,
        while(points[++i] && points[i].time - firstT < halfN) ;
        // there isnt even n seconds worth of data! get out of here
        if(!points[i] || lastT - points[i].time < halfN) {
          break;
        }

        // if we already did it gtfo
        if(points[i][avgMetric]) {
          break;
        }

        // alright, i is the first point where we are at least n/2 seconds
        // in, and we know we have at least n/2 seconds after i, so lets
        // do it
        //
        // we need to do the full calculation for the first point
        var res = this.timeWeightedAverage(baseMetric, points[i].time - halfN, points[i].time + halfN, null, points);
        points[i][avgMetric] = res.avg;

        var backI = res.outerStartI, frontI = res.innerEndI;
        var lastI = i;
        for(++i; lastT - points[i].time >= halfN; i++) {
          var time = points[i].time;
          var prevTime = points[i-1].time;

          // we move forward a point, which is deltaT seconds. we'll
          // discard/add this amount of time from the back/front
          var deltaT = time - prevTime;

          // figure out what we're going to add from the front
          var toAdd = this.timeWeightedAverage(baseMetric, prevTime + halfN, time + halfN, frontI, points);
          frontI = toAdd.innerEndI;

          // figure out what we're going to discard from the back
          var toDiscard = this.timeWeightedAverage(baseMetric, prevTime - halfN, time - halfN, backI, points);
          backI = toDiscard.outerStartI;

          // we're adding to / removing from this value
          var lastAvg = points[lastI][avgMetric];

          // we normalize by multiplying each value by the duration they
          // represent, then divide by our total duration n
          var newAvg = (n*lastAvg + deltaT*(toAdd.avg - toDiscard.avg)) / n;
          // we end up with rounding errors that are barely negative, get rid of them
          if(newAvg < 0 && newAvg > -0.0000001) newAvg=0;
          points[i][avgMetric] = newAvg;
          // keep track of max
          if(!max || max < newAvg) {
            max = newAvg;
            max_i = points[i]._idx;
          }
          // if we skip points because time is the same, this lastI
          // value still represents the last successful i. it was i-1
          // before, but once we encountered data with the same time,
          // i-1 didnt work in all cases.
          lastI = i;
        }
        maxes[n] = [max_i, max];
      }
      return maxes;
    },

    timeWeightedAverage: function(metric, startT, endT, startI, points) {
      if(!points) {
        points = this._data.points();
      }
      if(!startT) startT = 0;
      if(!endT) endT = points[points.length-2].time;
      if(!startI) startI = 1;
      // find startI, the idx of the first point after startT
      while(points[startI].time < startT) startI++;
      // calculate time weighted avg from startI through endI, the idx
      // of the last point before endT
      var i=startI;
      var avgTimesDuration=0;
      while(points[++i] && points[i].time <= endT) {
        var dt = points[i].time - points[i-1].time;
        var avg = (points[i][metric] + points[i-1][metric]) / 2;
        avgTimesDuration += dt * avg;
      }
      var endI = i - 1;
      // both start and end times fall between two consecutive points,
      // we overshoot and need to back up endI (which should always be
      // <= endT!
      if(points[endI].time > endT || points.length == endI+1) endI--;

      // calculate the extra interpolated bit at the beginning
      var firstPt = points[startI];
      var prevPt = points[startI-1];

      var leftDeltaT = firstPt.time - startT;
      var leftEstValue = firstPt[metric] - (firstPt[metric] - prevPt[metric]) * leftDeltaT / (firstPt.time - prevPt.time);
      // and the extra interpolated bit at the end
      var lastPt = points[endI];
      var nextPt = points[endI+1];
      var rightDeltaT = endT - lastPt.time;
      var rightEstValue = lastPt[metric] + (nextPt[metric] - lastPt[metric]) * rightDeltaT / (nextPt.time - lastPt.time)
      var finalAvg;
      if(endI < startI) {
        // both times fall between two points, so just average the
        // estimated values
        finalAvg = (leftEstValue + rightEstValue)/2;
      } else {
        var finalProduct = leftDeltaT * (leftEstValue+firstPt[metric])/2 + avgTimesDuration + rightDeltaT * (rightEstValue+lastPt[metric])/2;
        finalAvg = finalProduct / (endT - startT);
      }

      return {
        outerStartI: startI-1,
        innerEndI: endI,
        avg: finalAvg
      }
    },

    resampleEles: function(points, targetDelta, key) {
      var prevPoint, point, pts = [];
      //always start curDistance with first distance point. in some cases
      //we drop the first couple no ele points, so distance doesn't always
      //start at 0. this is to avoid 0->1000ft in the first couple points.
      var curVal = points[0][key], i = 0;

      pts.push({x: 0, y: points[0].ele || 0, yDelta: 0});
      //second condition double checks how much we are going to interpolate...
      //without putting a bounds on the span between points, we could add
      //an extra 100k points to interpolate!
      while(i < points.length) {
        point = points[i];

        if(prevPoint && Number.isFinite(point.ele) && prevPoint[key] <= curVal && point[key] > curVal && points[i][key] - curVal < 1000) {
          var xDelta = point[key] - prevPoint[key];
          var xPercent = (curVal - prevPoint[key]) / xDelta;
          var yDelta = point.ele - prevPoint.ele;
          var e = prevPoint.ele + xPercent*yDelta;

          pts.push({x: curVal, y: e, yDelta: yDelta});

          //incrementing only curVal in this case causes the next point
          //to get assigned an erroneous distance
          if((point[key] - curVal) < targetDelta) {
            i += 1;
            if (point.ele !== undefined)
              prevPoint = point;
          }
          curVal += targetDelta;
        } else {
          if (point.ele !== undefined)
            prevPoint = point;

          i += 1;
        }
      }
      return pts;
    },

    smoothEles: function() {
      var tpsWithEle = [], // everything we're doing here requires elevation, need to skip points without it
        idxMap = [],
        ySum = 0,
        filterPoints, // {x,y} objects required by the DJFilter
        resampledPoints; // evenly spaced points (on x dimension)

      // filter trackpoints to set that includes elevation, build id map to let us reference filtered array back to unfiltered
      for(var i=0; i < this._points.length; i++) {
        if(Number.isFinite(this._points[i].ele)) {
          idxMap[i] = tpsWithEle.length;
          tpsWithEle.push(this._points[i]);
        }
      }

      // abort early if there are no points with elevation.
      if(tpsWithEle.length === 0)
        return {results: [], idxMap: idxMap};

      //not all trips have lat/lng and distance, fallback to time if needed.
      //get a resampled set of elevation/distance pairs with a standardized
      //spacing of 20m or 2seconds. we use this dataset to determine the average
      //elevation gain/loss from point to point in order to tune calculations.
      if(this.hasDistance()) {
        filterPoints = _.map(tpsWithEle, function(pt) { return {x: pt.distance, y: pt.ele} });
        resampledPoints = this.resampleEles(tpsWithEle, 20, 'distance');
      } else {
        // DJFilter only uses |x - xPrev|, so absolute epoch time works as the x axis here.
        filterPoints = _.map(tpsWithEle, function(pt) { return {x: pt.time, y: pt.ele} });
        resampledPoints = this.resampleEles(tpsWithEle, 2, 'time');
      }

      _.each(resampledPoints, function(p) { ySum += Math.pow(p.yDelta, 6) });
      var yDeltaAvg = Math.pow(ySum / resampledPoints.length, 1/6);

      //magical tunable parameters
      var minSmoothing = 10;
      var maxSmoothing = 70;
      var minYDeltaAvg = 0.05;
      var maxYDeltaAvg = 8.0;
      var smoothing = minSmoothing;

      if(yDeltaAvg <= minYDeltaAvg) {
        smoothing = minSmoothing
      } else if(yDeltaAvg >= maxYDeltaAvg) {
        smoothing = maxSmoothing;
      } else {
        var avgDelta = yDeltaAvg - minYDeltaAvg;
        var avgDeltaPercent = avgDelta / (maxYDeltaAvg - minYDeltaAvg);
        smoothing = Math.round(minSmoothing + (maxSmoothing-minSmoothing)*avgDeltaPercent);
      }

      return {
        results: (new filter.DJFilter(filterPoints, smoothing)).filter(),
        idxMap: idxMap
      };
    },

    /*
     * Smooths out speed and grade
     * TODO: needs reworking, since this is just the AS code...
     */
    calculateGradeAndSpeed: function() {
      var d = this._data;
      var points = this._points;
      // get out of here if this has already been done
      // the reason we're hinging this on speed instead of grade, is because when drawing a route
      // we actually want to run this multiple times, but we continue smoothing from grade_orig
      // to prevent oversmoothing
      //
      // when processing a trip, we really only need to run it once though. this might change
      // when we allow editing of trips!
      if(!points[0] || (typeof points[0].speed_orig != "undefined")) return;

      var dist = 0;
      var speedDists = [];
      var speedIndexes = [];
      var speeds = [];
      var gradeDists = [];
      var gradeIndexes = [];
      var grades = [];


      var hasSpeed = this.hasMetric("speed");
      var hasGrade = this.hasMetric("grade");

      var skipped = 0;

      var i, prevPoint, point;
      var j = 0, k = 0;
      for(i=0; i < d.count; i++) {
        prevPoint = point;
        point = points[i];

        if(i > 0) {
          if(prevPoint.distance && point.distance) {
            dist += point.distance - prevPoint.distance;
          } else if(point.point && prevPoint.point) {
            dist += point.distanceFromPoint(prevPoint);
          }
        }

        if(hasSpeed) {
          if(point.speed == null) {
            // on points, speeds will be marked null to indicate invalid data.  These speeds will bring surrounding
            // values they will be completely excluded from the averaging set.  Using indexes to map smooth speeds back
            // onto the data.
            speedIndexes.push(null);
          } else {
            speeds.push(point.speed);
            speedDists.push(dist);
            speedIndexes.push(j);

            j++;
          }
        }
        if(hasGrade) {
          // when drawing a new route, this prevents successive runs from oversmoothing grade
          if (isNaN(point.grade_orig)) {
            skipped++;
            gradeIndexes.push(null);
          } else {
            grades.push(point.grade_orig);
            gradeDists.push(dist);
            gradeIndexes.push(k);

            k++;
          }
        }
      }

      var smoothSpeeds, smoothGrades, myfilter;

      if(hasSpeed) {
        myfilter = new filter.SincFilter(speedDists, speeds);
        smoothSpeeds = myfilter.filter();
        this.setMetric("speed", 'max', -50000);
        this.setMetric("speed", 'min', 50000);
      }

      if(hasGrade) {
        myfilter = new filter.LowPass(gradeDists, grades, 4.4);
        smoothGrades = myfilter.filter();
        this.setMetric("grade", 'max', -50000);
        this.setMetric("grade", 'min', 50000);
      }

      var lastSpeed = null;
      var lastGrade = null;
      var gradesAssigned = 0;

      for(i=0; i < d.count; i++) {
        point = points[i];

        if(hasSpeed) {
          if (point.speed_orig === undefined) {
            point.speed_orig = point.speed;
          }


          if (speedIndexes[i] !== null) {
            lastSpeed = smoothSpeeds[speedIndexes[i]];

            if (!point.exclude) point.speed = lastSpeed;

            if (lastSpeed > this.getMetric("speed", 'max')) {
              this.setMetric("speed", 'max', lastSpeed, i);
            }
            if (lastSpeed < this.getMetric("speed", 'min'))
              this.setMetric("speed", 'min', lastSpeed, i);
          } else {
            point.speed = lastSpeed;
          }
        }

        if (hasGrade) {
          if (gradeIndexes[i] != null) {
            gradesAssigned++;

            lastGrade = smoothGrades[gradeIndexes[i]];
            point.grade = lastGrade;

            if (lastGrade > this.getMetric("grade", 'max')) {
              this.setMetric("grade", 'max', lastGrade, i);
            }

            if (lastGrade < this.getMetric("grade", 'min')) {
              this.setMetric("grade", 'min', lastGrade, i);
            }

          } else {
            gradesAssigned++;
            point.grade = lastGrade;
          }
        }
      }
    },

    calculateNormalizedPower: function() {
      var d = this._data;
      var quads = [], sum = 0, i, pow, avg, pt, points = this._points;
      for(i = 0; i < d.count; i++) {
        pt = points[i];
        if(pt.watts_ma_30 != null) quads.push(Math.pow(pt.watts_ma_30, 4));
      }
      for(i = 0; i < quads.length; i++) {
        sum += quads[i];
      }
      avg = sum / quads.length;
      pow = Math.pow(avg, 1/4.0);
      this.setMetric("watts", "normalized", pow);
      return pow;
    },
    average: function(arr) {
      var sum = 0;
      for(var i = 0; i < arr.length; i++) {
        sum += arr[i];
      }
      return sum / arr.length;
    },
    calculateBestEfforts: function() {
      // need power for best efforts
      if(!this.hasPower()) return;
      var d = this._data;
      var bestEfforts = {};

      var durations = [30, 60];
      var points = this._points;
      var effortsToFind = 4;

      // gimme the index of the first point duration seconds before
      // or after point i
      function firstPoint(beforeOrAfter, i, duration) {
        // assuming i have points...
        var pt = points[i];
        var goalTime, j, pct;
        if(beforeOrAfter == 'after') {
          goalTime = pt.time + duration;
          j = i;
          while(d.points(j+1) && d.points(j).time <= goalTime) { j++; }
          --j;
          pct = (goalTime - d.points(j).time) / (d.points(j+1).time - d.points(j).time);
          return [j, pct];
        } else {
          goalTime = pt.time - duration;
          j = i;
          while(d.points(j-1) && d.points(j) && d.points(j).time >= goalTime) { j--; }
          pct = (goalTime - d.points(j).time) / (d.points(j+1).time - d.points(j).time);
          return [j, pct];
        }
      }

      for(var i=0;i<durations.length;i++) {
        var duration = durations[i], key = "watts_ma_"+duration;
        var halfDuration = duration / 2;
        // find effortsToFind best non-intersecting efforts
        var sortedPoints = _.sortBy(_.select(points,
                                             function(p) { return p && p[key]}),
                                    function(p) { return -p[key] });
        // all or nothing for now
        if(sortedPoints.length >= effortsToFind) {
          // ok snag the first one, woohoo its the best!
          // need to grab duration/2 seconds to the left and right
          bestEfforts[duration] = [];
          var sortedPtIdx = 0;
          var firstI = firstPoint('before', sortedPoints[0]._idx, halfDuration);
          var lastI = firstPoint('after', sortedPoints[0]._idx, halfDuration);
          bestEfforts[duration].push([firstI, lastI]);
          sortedPtIdx++;
          // alright find a few more
          var toFind = effortsToFind-1;
          var i1, i2;
          while(toFind > 0) {
            i1 = firstPoint('before', sortedPoints[sortedPtIdx]._idx, halfDuration);
            i2 = firstPoint('after', sortedPoints[sortedPtIdx]._idx, halfDuration);
            // make sure there are no intersections with any previous
            // best efforts
            if(_.all(bestEfforts[duration], function(be) {
              return (i1[0] < be[0][0] && i2[0] < be[0][0]) || (i1[0] > be[1][0] && i2[0] > be[1][0])
            })) {
              firstI = i1;
              lastI = i2;
              bestEfforts[duration].push([firstI, lastI]);
              toFind--;
            }
            sortedPtIdx++;
          }
        }
      }
      return bestEfforts;
    },

    calculateSpeedBuckets: function(metric = false) {
      // Raw data is in km/h, convert to mph as needed
      const speedScale = metric ? 1.0 : 0.621371
      const points = this._points
      let durations = {}
      let gteDurations = {}
      let gradeAvgs = {}
      let counts = {}
      let totalDuration = 0

      for (let i = 0; i < points.length; ++i) {
        const point = points[i]

        if (point.exclude) { continue }

        const speed = point.speed * speedScale
        const speedInt = Math.floor(speed)

        // Average the duration between adjacent points and scale down to minutes instead of seconds
        const prevPoint = points[i - 1]
        const nextPoint = points[i + 1]
        const t0 = (prevPoint && !prevPoint.exclude ? prevPoint : point).time
        const t1 = (nextPoint && !nextPoint.exclude ? nextPoint : point).time
        const duration = (t1 - t0) / (2.0 * 60)

        // we dont allow points with >30s gaps to contribute to avg speed, so disregard them
        if (duration > 0.5 || speedInt == 0) { continue }

        totalDuration += duration

        const prevCount = counts[speedInt] || 0
        const newCount = counts[speedInt] = prevCount + 1
        durations[speedInt] = (durations[speedInt] || 0) + duration
        gradeAvgs[speedInt] = ((gradeAvgs[speedInt] || 0) * prevCount + point.grade) / newCount
      }

      const speeds = Object.keys(durations)
      const minSpeed = Math.min(...speeds)
      const maxSpeed = Math.max(...speeds)

      for (let speed = minSpeed; speed <= maxSpeed; speed++) {
        // fill in any 0s
        if (!durations[speed]) { durations[speed] = 0 }
        if (!gradeAvgs[speed]) { gradeAvgs[speed] = 0 }

        // store duration of >= each speed
        gteDurations[speed] = totalDuration
        totalDuration -= durations[speed] || 0
      }

      return {
        durations: durations,
        gradeAvgs: gradeAvgs,
        gteDurations: gteDurations
      }
    },

    hasSurface: function () {
      if (this._hasSurface === undefined) {
        this._hasSurface = Object.keys(this.surfaces()).length > 0;
      }
      return this._hasSurface;
    },

    surfaces: function () {
      if (this._surfaces === undefined) {
        this._surfaces = this.calculateSurfaceTypes();
      }
      return this._surfaces;
    },

    calculateSurfaceTypes: function () {
      if (this._surfaces) {
        return this._surfaces
      }

      const points = this._points;
      if (points.length === 0) {
        return {}
      }
      const surfaces = {};

      let excluding = false;
      let lastDistance = 0;
      let lastSurface = `${points[0].surface}`; // smh string keys
      let hasSurface = true;
      points.forEach((pt, idx) => {
        if (pt.surface !== undefined) {
          // add pt distance to collector if surface changes
          const lastPt = points[idx - 1];
          const thisSurface = `${pt.surface}`
          if (idx > 0 && !lastPt.excludeFromMetrics && pt.excludeFromMetrics) {
            // entering an excludeFromMetrics zone, don't count distances until we're including in metrics again
            excluding = true;
            if (Object.keys(surfaces).indexOf(lastSurface) === -1) {
              surfaces[lastSurface] = 0;
            }

            surfaces[lastSurface] += pt.distance - lastDistance;
          } else if (idx > 0 && lastPt.excludeFromMetrics && !pt.excludeFromMetrics) {
            // leaving an excludeFromMetrics zone, set up to count the next surface change
            excluding = false;
            lastDistance = points[idx - 1].distance;
            lastSurface = thisSurface;
          } else if (!excluding && thisSurface !== lastSurface) {
            // surface changed! add the distance from the last change to the last surface aggregator
            if (Object.keys(surfaces).indexOf(lastSurface) === -1) {
              surfaces[lastSurface] = 0;
            }

            surfaces[lastSurface] = surfaces[lastSurface] + (lastPt.distance - lastDistance);
            lastDistance = lastPt.distance;
            lastSurface = thisSurface;
          }
        } else {
          // if ANY tp has surface === undefined, infer that this route was
          // created before st, so we won't show any st in the planner or in
          // the trsp
          hasSurface = false;
        }
      });

      // do it one more time for the last point
      const veryLastPt = points[points.length - 1]
      const veryLastSurface = `${veryLastPt.surface}`
      if (veryLastSurface !== 'undefined' && !excluding) {
        if (Object.keys(surfaces).indexOf(veryLastSurface) === -1) {
          surfaces[veryLastSurface] = 0;
        }
        surfaces[veryLastSurface] += veryLastPt.distance - lastDistance;
      }
      if (Object.keys(surfaces).length > 0 && hasSurface) {
        surfaces._max = true // appease this.hasMetric
      }

      this._surfaces = surfaces
      return surfaces
    }
  }

  module.exports = MetricsCalculator;
})();



// WEBPACK FOOTER //
// ./public/javascripts/js_maps/metrics_calculator.js